module.exports = __webpack_public_path__ + "img/tikitaka.564c0ebc.jpg";